import React from 'react';
import { Modal, Card, Row, Col, Button, message } from 'antd';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { connect } from 'dva';
import styles from './Index.less';

@connect(({ CheckQRCode, loading }) => ({
  checkQRCode: CheckQRCode.checkQRCode,
  contentLoading: loading.effects['CheckQRCode/fetchPayInfo'],
}))
export default class CheckQRCode extends React.Component {
  constructor(props) {
    super(props);

    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleCopied = this.handleCopied.bind(this);
    this.renderQRCode = this.renderQRCode.bind(this);
  }

  handleCopied(text, result) {
    if (!result || !text) {
      return Modal.warning({
        title: '提示',
        content: `复制失败，请手动复制链接 ${this.props.checkQRCode.url}`,
      });
    }
    message.success('链接已成功复制到剪贴板');
  }

  handleCloseModal() {
    this.props.dispatch({
      type: 'CheckQRCode/setPayInfo',
      payload: {
        visible: false,
      },
    });
  }

  renderQRCode() {
    const { contentLoading } = this.props;
    const { url, qrCode } = this.props.checkQRCode;

    return (
      <Card bordered={false} loading={contentLoading}>
        <p className={styles['card-title']}>将支付链接或者二维码发送给家长</p>
        <Row className="url-wrap">
          <Col md={5} xs={24} className={styles['wrap-container']}>
            *支付链接：
          </Col>
          <Col md={13} xs={24} className={styles['wrap-container']}>
            <p className={styles['card-url']}>{url}</p>
          </Col>
          <Col md={4} xs={24} offset={1}>
            <CopyToClipboard text={url} onCopy={this.handleCopied}>
              <Button type="primary">点击复制</Button>
            </CopyToClipboard>
          </Col>
        </Row>
        <Row className="image-wrap">
          <Col md={5} xs={24} className={styles['wrap-container']}>
            二维码：
          </Col>
          <Col md={13} xs={24} className={styles['wrap-container']}>
            <img className="image" src={qrCode} alt="支付二维码" />
          </Col>
        </Row>
      </Card>
    );
  }

  renderEndTip = () => {
    return (
      <Card bordered={false}>
        <Row className="strong">
          <Col>本次收费已截止！</Col>
        </Row>
        <Row className="small">
          <Col>仅在收费截止前，展示支付二维码</Col>
        </Row>
      </Card>
    );
  };

  render() {
    const { visible, status } = this.props.checkQRCode;

    if (visible !== true) {
      return null;
    }

    let component;
    switch (status) {
      case '到期':
        component = this.renderEndTip();
        break;
      default:
        component = this.renderQRCode();
        break;
    }

    return (
      <Modal
        className={styles.root}
        title="查看支付二维码"
        visible={visible}
        onCancel={this.handleCloseModal}
        onOk={this.handleCloseModal}
      >
        {component}
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components_business/CheckQRCode/Index.js